import clsx from 'clsx';
import React from 'react';

import Spinner from '@components/Spinner';

import { DEFAULT_READING_STAT_VALUES } from './constants';

interface ForYouReadingStatProps {
  index: number;
  isLast: boolean;
  name: string | React.ReactNode;
  small?: boolean;
  value: string | number;
}

const ForYouReadingStat = ({ isLast, name, small = false, value }: ForYouReadingStatProps) => {
  return (
    <div className="flex-1 border-0 border-solid border-grayscale-gray sm:flex-none sm:border-r sm:pr-32 sm:last-of-type:border-r-0 lg:pr-64 [&:last-of-type_dd]:border-r-0">
      <dl className="m-0 flex h-full flex-col items-center justify-start gap-0 text-center sm:flex-col-reverse sm:gap-16">
        <dt className="m-0 h-32 w-full border-0 border-b border-solid border-grayscale-gray font-suisse-intl-mono text-overline-sm text-primary-black sm:h-auto sm:border-b-0 sm:text-caption-sm md:h-auto [@media(min-width:25rem)]:h-20">
          {name}
        </dt>
        <dd
          className={clsx(
            'm-0 flex w-full flex-1 items-center justify-center border-0 border-r border-solid border-grayscale-gray px-8 pt-20 font-suisse-screen text-primary-magenta sm:flex-none sm:border-r-0 sm:px-0 sm:pt-0',
            small
              ? 'text-overline-md sm:text-headline-alt-sm sm:!leading-[52px]'
              : 'text-headline-alt-sm sm:text-headline-alt-md',
            isLast && 'border-r-0'
          )}
        >
          {DEFAULT_READING_STAT_VALUES.includes(value) ? (
            <span className="text-grayscale-gray">
              <Spinner marginY="small" />
            </span>
          ) : (
            value
          )}
        </dd>
      </dl>
    </div>
  );
};

export default ForYouReadingStat;
